<template>
  <div>
    <span v-if="conditionList.length" class="btn_tips topTips">{{ tipsString(tips,type) }}</span>
    <div
      v-for="(item,index) in conditionList"
      :key="index"
      class="item"
    >
      <div v-if="item.length" class="or_condition">
        <div
          class="deleteOr"
          @click="handleOrDelete(index)"
        >
          删除
        </div>
        <div
          v-for="(child,i) in item"
          :key="i"
          class="conition_item flex"
        >
          <el-form-item
            label-width="0px"
            :prop="`${validateString}.${index}.${i}.fieldName`"
            :rules="CONDITION_RULES.TYPE"
          >
            <el-select
              v-model="child.fieldName"
              placeholder="请选择"
              @change="handleChange(child,`${validateString}.${index}.${i}.fieldValue`)"
            >
              <el-option
                v-for="option in conditionTypeOption"
                :key="option.value"
                :label="option.label"
                :disabled="isDisabled(option.value,item)"
                :value="option.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label-width="0px"
            :prop="`${validateString}.${index}.${i}.judge`"
            :rules="CONDITION_RULES.CONDITION"
          >
            <el-select
              v-model="child.judge"
              :disabled="child.fieldName===CONDITION_TYPE.ASSIGNED||child.fieldName===CONDITION_TYPE.TRANSPORT_COST"
              placeholder="请选择"
            >
              <el-option
                v-for="option in conditionKindOption"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label-width="0px"
            :prop="`${validateString}.${index}.${i}.fieldValue`"
            :rules="child.fieldName!==CONDITION_TYPE.ROOT_CUSTOMER_NAME?CONDITION_RULES.CONDITION_VALUE:[]"
          >
            <el-input
              v-if="isInput(child.fieldName)"
              v-model="child.fieldValue"
              :placeholder="placeholder(child.fieldName)"
            />
            <el-select
              v-else
              v-model="child.fieldValue"
              :placeholder="placeholder(child.fieldName)"
            >
              <el-option
                v-for="option in writeTypeOption(child.fieldName)"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </el-select>
          </el-form-item>
          <div class="active_bar">
            <i
              v-if="item.length>1"
              class="el-icon-error clear_icon"
              @click="handleDelete(index,i)"
            />
          </div>
        </div>
        <el-button
          icon="el-icon-plus"
          @click="handleAddAndCondition(index)"
        >
          添加且条件
        </el-button>
      </div>
      <div class="relation_bar">
        <span class="relation">或</span>
      </div>
    </div>
    <div class="item">
      <div class="addOrCondition_btn flex flex-center" @click="handleAddOrCondition">
        <span>
          <i class="el-icon-plus" />
          {{ conditionList.length?'添加或条件':'添加条件' }}
        </span>
      </div>
      <span v-if="!conditionList.length" class="btn_tips">{{ tipsString(tips,type) }}</span>
    </div>
  </div>
</template>

<script>
import { processingSelectData } from '@/utils/index';
import {
  CONDITION_TYPE, CONDITION_TYPE_MAP, WRITE_TYPE, CONDITION_RULES, ORDER_CHANNEL,
} from './const';

const tipsType = {
  create: '满足条件的订单“允许补录”，否则不允许补录',
  receiving: '满足条件规则的订单应用所选设置',
  billing: '满足条件规则的订单应用所选设置',
};
export default {
  name: 'AddCondition',
  props: {
    conditionList: {
      type: Array,
      default: () => ([]),
    },
    validateString: {
      type: String,
      default: '',
    },
    tips: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    conditionType: {
      type: Array,
      default: () => ([]),
    },
    conditionKind: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tipsType,
      CONDITION_RULES,
      CONDITION_TYPE,
      CONDITION_TYPE_MAP,
      ORDER_CHANNEL,
    };
  },
  computed: {
    conditionTypeOption() {
      return this.conditionType;
    },
    conditionKindOption() {
      return processingSelectData(this.conditionKind);
    },
    placeholder() {
      return (type) => {
        if (type === CONDITION_TYPE.ASSIGNED || type === CONDITION_TYPE.TRANSPORT_COST) {
          return (type ? `请选择${CONDITION_TYPE_MAP[type]}` : '请选择');
        }
        return (type ? `请输入${CONDITION_TYPE_MAP[type]}` : '请输入');
      };
    },
    isInput() {
      return (type) => (!(type === CONDITION_TYPE.ASSIGNED || type === CONDITION_TYPE.TRANSPORT_COST || type === CONDITION_TYPE.ORDER_CHANNEL));
    },
    writeTypeOption() {
      return (type) => (type === CONDITION_TYPE.ORDER_CHANNEL ? processingSelectData(ORDER_CHANNEL) : WRITE_TYPE);
    },
    tipsString() {
      return (tips, Type) => (tips ? `${tipsType[Type] + tips}` : `${tipsType[Type]}`);
    },
    isDisabled() {
      return (value, item) => item.some((option) => option.fieldName === value);
    },
  },
  methods: {
    handleAddOrCondition() {
      this.$emit('addOrCondition');
    },
    handleAddAndCondition(index) {
      this.$emit('addAdnCondition', index);
    },
    handleDelete(index, i) {
      this.$emit('delete', { index, itemIndex: i });
    },
    handleOrDelete(index) {
      this.$emit('orDelete', { index });
    },
    handleChange(item, prop) {
      if (item.fieldName && item.fieldName === CONDITION_TYPE.ROOT_CUSTOMER_NAME) {
        this.$emit('clearValidate', prop);
      }
      if (item.fieldName === CONDITION_TYPE.ASSIGNED || item.fieldName === CONDITION_TYPE.TRANSPORT_COST) {
        // eslint-disable-next-line no-param-reassign
        item.judge = 'EQ';
      }
      // eslint-disable-next-line no-param-reassign
      item.fieldValue = '';
    },
  },

};
</script>

<style lang="scss" scoped>
.or_condition{
  padding: 24px;
  background: #F5F7FA;
  border-radius: 4px;
  margin-bottom: 16px;
  .deleteOr{
    text-align: right;
    cursor: pointer;
    color: #1890FF;
    font-size: 14px;
  }
}
.conition_item{
  .el-input,
  .el-select{
    width: 100%;
  }
  .el-form-item{
    flex: 1;
    margin-right: 24px;
    margin-bottom: 16px;
    .el-form-item__content{
      margin-left: 0px;
    }
  }
  .clear_icon{
    margin-bottom: 16px;
    margin-right: 24px;
  }
}
.btn_tips{
  color: #808792;
  font-size: 14px;
  // margin-left: 16px;
}
.item{
  margin-bottom: 16px;
}
.item:nth-last-child(2){
  .relation_bar{
    display: none !important;
  }

}
.topTips{
  margin-bottom: 8px;
  display: inline-block;
}
.relation_bar{
  width: 100%;
  display: flex;
  align-items: center;
  &::before{
    content: '';
    display: inline-block;
    height: 1px;
    background:  #D9DBDE;
    flex: 1;
  }
  &::after{
    content: '';
    display: inline-block;
    height: 1px;
    background:  #D9DBDE;
    flex: 1;
  }
  .relation{
    color: #000F25;
    font-weight: 500;
    font-size: 14px;
    margin: 0 16px;
  }
}
.active_bar{
  width: 80px;
  padding-top: 4px;
  span{
    color: #1890FF;
    font-size: 14px;
  }
}
.addOrCondition_btn{
  cursor: pointer;
  height: 38px;
  border: 1px dashed #B3B7BE;
  font-size: 14px;
  .el-icon-plus{
    margin-right: 10px;
  }
  &:hover{
    border-color: #51CDA6;
    color: #51CDA6;
  }
  &:focus{
    border-color: #059366;
    color: #059366;
  }
}
</style>
